import Service from "../Service";

const resource = "RequirementApproval/";

export default {
   

    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
 
};